/* eslint-disable max-len */
const jaJp = {
  CancellationRequest: 'キャンセルのリクエスト',
  Heading: '下記の情報をご入力ください。すべての項目は入力必須です。',
  Note: '予約のキャンセルをご希望ですか ? よくあるご質問以下のフィールドに、キャンセルをご希望の予約に関する情報を入力してください。',
  PartnerNote:
    'ありがとうございました。弊社ではご出発日が近いお客様を優先し、順次対応しております。旅行のご出発日より前に弊社からキャンセルの確認通知が届かない場合は、弊社にてキャンセル手続き中と考えられます。お客様によるお手続きは一切不要です。',
  SubmitNote:
    '現在、多くのお問い合わせに対応しているため、返金手続きに時間がかかる場合があります。ご不便をおかけして誠に申し訳ございません。ご理解とご協力をお願い申し上げます。',
  Disclaimer:
    'こちらのフォームは 2021 年 12 月 31 日までにご出発・チェックイン予定の場合にのみご利用ください。',
  Itin: '旅程番号 (旅程または予約確認メールに記載されている 11 ～ 15 桁の番号)',
  EmailAddress: '予約時に利用したEメールアドレス',
  PhoneNumber: '予約時に利用した電話番号',
  Reason: '理由',
  Submit: '続行',
  Success: 'リクエストを受領しました',
  Failed: '申し訳ありません',
  InProgress: 'リクエストの処理を行っております',
  TryAgain: '戻る',
  PhoneErrorMessage: '有効な電話番号を入力してください',
  EmailErrorMessage: '有効なEメールアドレスを入力してください',
  ItinErrorMessage: '有効な旅程番号を入力してください',
  ResponseEligibleHeader: 'お客様の旅程が見つかりました',
  ResponseEligibleSubmit: 'キャンセルする',
  ResponseEligibleNeverMind: 'キャンセルしない',
  ResponseOnlyLodgingWithRefund:
    '返金の対象となる予約が {x} 件あります。予約をキャンセルした場合は、予約時にご利用のお支払い方法で返金されます。',
  ResponseOnlyLodgingWithCoupon:
    '優待クーポンの対象にとなる予約が {x} 件あります。予約をキャンセルした場合は、予約のお支払い金額に相当する優待クーポンが発行されます。',
  ResponseOnlyLodgingInEligible:
    '{x} 件の予約はキャンセル料無料の対象ではありません。予約をキャンセルした場合は、宿泊施設の通常のキャンセルポリシーが適用されます。',
  ResponseLodgingWithOtherLob:
    'この旅程に関する他のすべての予約は、提携各社の規定が適用されます。',
  ResponseNoLodgingWithOtherLob:
    'この旅程に関するすべての予約は、提携各社の規定が適用されます。',
  ResponseAlreadyCancelled:
    'キャンセル済みの宿泊施設の予約が {x} 件あります。現在、多くのお問い合わせに対応しているため、返金手続きに時間がかかる場合があります。ご不明な点がございましたら、弊社のカスタマーサポートまでご連絡ください。',
  ResponseNoFlexAvailable:
    '{x} 件の予約は、返金または優待クーポンの対象となりません。今、予約をキャンセルした場合、宿泊施設の通常のキャンセルポリシーが適用されます。キャンセルポリシーは変更される場合があります。旅程開始日の 8 日前に、再度こちらのページにて最新のキャンセルポリシーをご確認ください。',
  ResponseInvalidDuplicateItinerary:
    'このリクエストは既に送信されています。弊社ではご出発日が近いお客様を優先し、順次対応しております。旅行のご出発日より前に弊社からキャンセルの確認通知が届かない場合は、弊社にてキャンセル手続き中と考えられます。その場合もお客様にご対応いただく必要はございません。',
  ResponseElligibleConfirmation: '予約のキャンセルをご希望ですか ?',
  ResponseInvalidUnknown:
    '入力された旅程番号または確認番号が見つかりません。番号をご確認のうえ、もう一度お試しください。番号は、最初に予約された際に受信された弊社からのEメールに記載されています。',
  ResponseInvalidItineraryNotFound:
    '入力された旅程番号または確認番号が見つかりません。番号をご確認のうえ、もう一度お試しください。番号は、最初に予約された際に受信された弊社からのEメールに記載されています。',
  ResponseInvalidTripMoreThanSevenDays:
    '申し訳ございませんが、リクエストを処理できませんでした。',
  ResponseInvalidTripIsLcc:
    '予約のキャンセルはすべて、ご利用の航空会社が行っています。航空会社に直接お問い合わせください。詳細はアカウントにログインのうえ、旅程にアクセスしてご確認ください。現在キャンセル手続きを行っている予約は、キャンセルの完了が旅程に反映されるまでに最大 72 時間かかる場合があります。',
  ResponseInvalidTripIsTicketless:
    '予約のキャンセルはすべて、ご利用の航空会社が行っています。航空会社に直接お問い合わせください。詳細はアカウントにログインのうえ、旅程にアクセスしてご確認ください。現在キャンセル手続きを行っている予約は、キャンセルの完了が旅程に反映されるまでに最大 72 時間かかる場合があります。',
  ResponseInvalidItinerary:
    'この旅程番号を認識できません。もう一度お試しください。',
  ResponseInvalidStatus: '問題が発生しました。もう一度お試しください。',
  ResponseInvalidEmail:
    'このEメールアドレスを認識できません。または、この旅程に利用されたEメールアドレスと合致しません。予約時にご利用になったEメールアドレスと一致していることをご確認ください。',
  ResponseInvalidPhone:
    'この電話番号を認識できません。予約時にご利用になった電話番号と一致していることをご確認ください。',
  ResponseTripHasLccFlight:
    'お客様の予約のうち、一部の予約をキャンセルすることができません。弊社でキャンセルすることができない予約については、提供元に直接お問い合わせください。キャンセルできなかった予約は、オンラインの旅程でご確認いただけます。現在キャンセル手続きを行っている予約は、キャンセルの完了が旅程に反映されるまでに最大 72 時間かかる場合があります。',
  ResponseErrorTripWithin24Hrs:
    'ご出発日・チェックイン日まで 24 時間以内となっておりますので、キャンセル処理はできません。詳細はアカウントにログインのうえ、旅程にアクセスしてご確認ください。',
  ResponseInvalidTripInCruise:
    'こちらのフォームはクルーズのキャンセル リクエストにはご利用いただけませんアカウントにログインして旅程にアクセスし、オンラインでキャンセル手続きを実行してください。',
};

export default jaJp;
